import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BookmarkIcon, CheckIcon } from 'lucide-react';
import type { ShowStatus } from '../types/show';
interface StatusToggleProps {
  kind: ShowStatus;
  checked: boolean;
  label: string;
  onToggle: () => void;
}
export function StatusToggle({
  kind,
  checked,
  label,
  onToggle
}: StatusToggleProps) {
  const Icon = kind === 'seen' ? CheckIcon : BookmarkIcon;
  const checkedClass = kind === 'seen' ? 'border-ink bg-ink' : 'border-want bg-want';
  return <button type="button" role="checkbox" aria-checked={checked} aria-label={label} onClick={onToggle} className="grid h-11 w-11 shrink-0 place-items-center rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink focus-visible:ring-offset-2 focus-visible:ring-offset-paper" data-id="element-80" data-mp="1gwokmqefsxcu">
      <span className={`grid h-6 w-6 place-items-center border-[1.5px] transition-[background-color,border-color,transform] duration-150 ease-out active:scale-90 ${checked ? checkedClass : 'border-ink/60 bg-paper hover:border-ink'}`} data-id="element-81" data-mp="24ko91joa0bo9">
        <AnimatePresence initial={false} data-id="element-82" data-mp="3b81yf8a6adbc">
          {checked && <motion.span initial={{
          scale: 0.6,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.6,
          opacity: 0
        }} transition={{
          duration: 0.14,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-83" data-mp="3f8u8g3qvcm8o">
              <Icon className="h-4 w-4 text-paper" strokeWidth={3} aria-hidden="true" data-id="element-84" data-mp="3p5grqo3jr58l" />
            </motion.span>}
        </AnimatePresence>
      </span>
    </button>;
}